module.exports = __webpack_public_path__ + "static/media/Piercing-belly.673b0596.png";